import { render, staticRenderFns } from "./DesformView.vue?vue&type=template&id=195f7b41&scoped=true&"
import script from "./DesformView.vue?vue&type=script&lang=js&"
export * from "./DesformView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195f7b41",
  null
  
)

export default component.exports